import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import ReportTable from "Reporting/Components/ReportTable";
import { useActiveTickets } from "./useActiveTickets";
import Loader from "shared/Loader";

/*
 * Table displaying different items in a report with the functionality to sort
 */
export default function ReportTableList({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);

  const { data, isLoading, isError, refetch } = useActiveTickets({
    year: filters.year,
    type: filters.type,
    owners: filters.owners,
  });

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      // trigger a refetch when parent signals
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (data) {
      setReports(data);
      setReportsLength(data.length || 0);
      setReportData?.(data);
    }
  }, [data]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (reports.length == 0) {
    return <div>No Reports Found</div>;
  }
  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <ReportTable
          item={report}
          index={index}
          reports={reports}
          key={index}
        />
      ))}
    </div>
  );
}

ReportTableList.propTypes = {
  /**
   * Diamond name
   */
  item: PropTypes.arrayOf({
    diamond: PropTypes.string,
    iboNum: PropTypes.string,
    name: PropTypes.string,
    tickets: PropTypes.number,
    pinLevel: PropTypes.string,
    bonus20Tix: PropTypes.number,
    bonus15: PropTypes.number,
    bonus20: PropTypes.number,
    pv1000: PropTypes.number,
    pv600: PropTypes.number,
    doubleEagle: PropTypes.number,
    eagle: PropTypes.number,
    bronze: PropTypes.number,
    plat: PropTypes.number,
    em: PropTypes.number,
    dia: PropTypes.number,
    silvers: PropTypes.number,
    golds: PropTypes.number,
    movingUp: PropTypes.number,
    eagleBreakfast: PropTypes.number,
    platinumEvent: PropTypes.number,
  }),
  header: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
};
